export function resetNodeStyle(nodes) {
    for (const node of nodes) {
        node.data.style = {}
    }

    this.logger.info('已重置节点样式', nodes)
}
